import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [dark, setDark] = useState(localStorage.getItem("pk_theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("pk_theme", dark ? "dark" : "light");
  }, [dark]);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return data; // { pending: true, message }
  };

  const exitImpersonation = async () => {
    await api.post("/auth/logout").catch(() => {});
    window.location.href = "/admin/clients";
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, exitImpersonation, dark, setDark }}>
      {children}
    </AuthContext.Provider>
  );
}
